import { FC, lazy, LazyExoticComponent } from 'react';
import { BrandVisual } from './Brand.types';

export const assets: Record<BrandVisual, LazyExoticComponent<FC>> = {
  'Axo Group': lazy(
    () => import('../../@assets/brand/axo-group-logo.svg?react')
  ),
  'axo-finans': lazy(
    () => import('../../@assets/brand/axo-finans-logo.svg?react')
  ),
  'axo-laina': lazy(
    () => import('../../@assets/brand/axo-laina-logo.svg?react')
  ),
  lendme: lazy(() => import('../../@assets/brand/lendme-logo.svg?react')),
  'lendme.axo': lazy(
    () => import('../../@assets/brand/lendme-axo-logo.svg?react')
  ),
  'uloan.axo': lazy(
    () => import('../../@assets/brand/uloan-axo-logo.svg?react')
  ),
  uscore: lazy(() => import('../../@assets/brand/uscore-logo.svg?react')),
  zmarta: lazy(() => import('../../@assets/brand/zmarta-logo.svg?react')),
  'zmarta.axo': lazy(
    () => import('../../@assets/brand/zmarta-axo-logo.svg?react')
  ),
  elskling: lazy(() => import('../../@assets/brand/elskling-logo.svg?react')),
  'freedom-finance': lazy(
    () => import('../../@assets/brand/freedom-finance-logo-white.svg?react')
  ),
  'freedom-finance--dark': lazy(
    () => import('../../@assets/brand/freedom-finance-logo.svg?react')
  ),
  'freedom-rahoitus': lazy(
    () => import('../../@assets/brand/freedom-rahoitus-logo-white.svg?react')
  ),
  'freedom-rahoitus--dark': lazy(
    () => import('../../@assets/brand/freedom-rahoitus-logo.svg?react')
  ),
  centum: lazy(() => import('../../@assets/brand/centum-logo.svg?react')),
  'centum.axo': lazy(
    () => import('../../@assets/brand/centum-axo-logo.svg?react')
  ),
};
